<div class="expired-page">

  <!-- Top banner -->
  <div class="expired-banner">
    <div class="expired-banner-icon">
      <i class="mdi mdi-lock-outline"></i>
    </div>
    <div class="expired-banner-info">
      <h2 class="expired-banner-title">Subscription Expired</h2>
      <p class="expired-banner-subtitle">{{ statusData?.statusMessage || 'Your subscription has expired. Please renew to continue using AdvERP.' }}</p>
    </div>
    <div class="expired-banner-stats" *ngIf="statusData">
      <div class="expired-stat">
        <span class="expired-stat-label">Expired On</span>
        <span class="expired-stat-value">{{ statusData.endDate | date: 'd MMM yyyy' }}</span>
      </div>
      <div class="expired-stat-divider"></div>
      <div class="expired-stat">
        <span class="expired-stat-label">Days Overdue</span>
        <span class="expired-stat-value text-danger">{{ statusData.overdueDays }} days</span>
      </div>
      <div class="expired-stat-divider" *ngIf="statusData.monthlyTotalAmount"></div>
      <div class="expired-stat" *ngIf="statusData.monthlyTotalAmount">
        <span class="expired-stat-label">Amount Due</span>
        <span class="expired-stat-value">₹{{ statusData.monthlyTotalAmount | number: '1.0-0' }}</span>
      </div>
    </div>
    <button class="expired-logout-btn" (click)="logout()">
      <i class="mdi mdi-logout me-1"></i> Logout
    </button>
  </div>

  <!-- 3-column grid -->
  <div class="expired-grid">

    <!-- Col 1: Amount Breakdown -->
    <div class="expired-card" *ngIf="statusData && statusData.monthlyTotalAmount">
      <div class="expired-card-header">
        <i class="mdi mdi-receipt-text-outline me-2"></i> Amount Breakdown
      </div>
      <div class="expired-card-body">
        <div class="expired-amount-row" *ngIf="statusData.baseAmount">
          <span class="expired-amount-label">Base Plan Amount</span>
          <span class="expired-amount-value">₹{{ statusData.baseAmount | number: '1.0-0' }}</span>
        </div>
        <div class="expired-amount-row" *ngIf="statusData.extraUserBlocks">
          <span class="expired-amount-label">Extra Users ({{ statusData.extraUserBlocks }} block<span *ngIf="statusData.extraUserBlocks > 1">s</span>)</span>
          <span class="expired-amount-value">₹{{ statusData.extraUserAmount | number: '1.0-0' }}</span>
        </div>
        <div class="expired-amount-row subtotal" *ngIf="statusData.monthlySubtotal">
          <span class="expired-amount-label">Subtotal</span>
          <span class="expired-amount-value">₹{{ statusData.monthlySubtotal | number: '1.0-0' }}</span>
        </div>
        <div class="expired-amount-row" *ngIf="statusData.gstAmount">
          <span class="expired-amount-label">GST ({{ statusData.gstPercent }}%)</span>
          <span class="expired-amount-value">₹{{ statusData.gstAmount | number: '1.0-0' }}</span>
        </div>
        <div class="expired-amount-row total">
          <span class="expired-amount-label">Total Due</span>
          <span class="expired-amount-value">₹{{ statusData.monthlyTotalAmount | number: '1.0-0' }}</span>
        </div>
      </div>
      <div class="expired-card-footer">
        <i class="mdi mdi-information-outline me-1"></i>
        After payment, email your reference to
        <a href="mailto:info@advinsoftwares.com">info@advinsoftwares.com</a>
      </div>
    </div>

    <!-- Col 2: Bank Transfer Details -->
    <div class="expired-card">
      <div class="expired-card-header">
        <i class="mdi mdi-bank-outline me-2"></i> Bank Transfer Details
      </div>
      <div class="expired-card-body">
        <div class="expired-bank-row" *ngFor="let row of [
          { label: 'Beneficiary', value: bankDetails.beneficiary, key: 'beneficiary' },
          { label: 'Account No', value: bankDetails.accountNo, key: 'accountNo' },
          { label: 'Bank Name', value: bankDetails.bankName, key: 'bankName' },
          { label: 'IFSC Code', value: bankDetails.ifscCode, key: 'ifscCode' },
          { label: 'GSTIN', value: bankDetails.gstin, key: 'gstin' },
          { label: 'UPI ID', value: bankDetails.upiId, key: 'upiId' }
        ]">
          <span class="expired-bank-label">{{ row.label }}</span>
          <span class="expired-bank-value">{{ row.value }}</span>
          <button class="expired-copy-btn" (click)="copyToClipboard(row.value, row.key)" [title]="'Copy ' + row.label">
            <i class="mdi" [ngClass]="copiedField === row.key ? 'mdi-check' : 'mdi-content-copy'"></i>
          </button>
        </div>
      </div>
    </div>

    <!-- Col 3: QR Code -->
    <div class="expired-card expired-card-qr">
      <div class="expired-card-header qr-header">
        <i class="mdi mdi-qrcode me-2"></i> Scan &amp; Pay via UPI
      </div>
      <div class="expired-card-body align-center">
        <div class="expired-qr-wrap">
          <img [src]="qrCodeUrl" alt="UPI QR Code" class="expired-qr-img" />
        </div>
        <div class="expired-qr-upi">
          <i class="mdi mdi-cellphone me-1"></i>
          <span>{{ bankDetails.upiId }}</span>
          <button class="expired-copy-btn ms-2" (click)="copyToClipboard(bankDetails.upiId, 'qrUpi')" title="Copy UPI ID">
            <i class="mdi" [ngClass]="copiedField === 'qrUpi' ? 'mdi-check' : 'mdi-content-copy'"></i>
          </button>
        </div>
        <p class="expired-qr-note">Scan with any UPI app</p>
        <div class="expired-upi-apps">
          <span class="expired-upi-badge">PhonePe</span>
          <span class="expired-upi-badge">GPay</span>
          <span class="expired-upi-badge">Paytm</span>
          <span class="expired-upi-badge">BHIM</span>
        </div>
      </div>
    </div>

  </div>

</div>
